import * as React from "react";
const SvgNick = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 128 128", contentScriptType: "text/ecmascript", ...props }, /* @__PURE__ */ React.createElement("text", { x: 85, y: 77, style: {
  fontSize: "12pt",
  stroke: "none",
  fill: "gray",
  fillOpacity: 1,
  fontFamily: "&quot"
}, transform: "matrix(0 3.66667 -3.18281 0 291.85 -260.184)" }, "\n		X\n	"));
export default SvgNick;
